import { Button } from '@creditornot/cb-button';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { StringParam, useQueryParams } from 'use-query-params';

import CityRushWithBag from 'common/illustrations/CityRushWithBag';
import { Typography as T } from 'common/typography';
import PageLoadError from 'core/PageLoadError';

type Props = {
  onStart: (onboardingToken: string, emailToken: string) => void;
};

const Heading = styled(T.Heading2)`
  text-align: center;

  @media (width <= 640px) {
    font-size: 32px;
  }
`;

const StartButton = styled(Button).attrs({
  size: 'large',
  variant: 'primary',
})`
  @media (width <= 640px) {
    width: 100%;
  }
`;

const ContactSupport = styled(T.Body3)`
  text-align: center;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  text-align: center;
`;

const Root = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 480px;
  height: 100%;
  margin: 0 auto;
  padding-inline: 16px;

  ${Heading} {
    margin-block-start: 32px;
  }

  ${Body} {
    margin-block-start: 16px;
  }

  ${StartButton} {
    margin-block-start: 32px;
  }

  ${ContactSupport} {
    margin-block-start: 16px;
  }
`;

const Start = ({ onStart }: Props) => {
  const [query] = useQueryParams({ onboardingToken: StringParam, emailToken: StringParam });
  const { onboardingToken, emailToken } = query;

  if (!onboardingToken || !emailToken) {
    return <PageLoadError />;
  }

  return (
    <Root>
      <CityRushWithBag width={320} />
      <Heading>
        <FormattedMessage id="merchant-sign-up.start.heading" />
      </Heading>
      <Body>
        <T.Body1>
          <FormattedMessage id="merchant-sign-up.start.body" />
        </T.Body1>
      </Body>
      <StartButton onClick={() => onStart(onboardingToken, emailToken)} data-test-id={'merchant-sign-up-start'}>
        <FormattedMessage id="merchant-sign-up.start.call-to-action" />
      </StartButton>
    </Root>
  );
};

export default Start;
